<template>
<div>
  <v-layout v-if="loading" row justify-center>
    <v-flex class="text-xs-center py-5 my-5" xs12>
      <v-progress-circular color="accent" indeterminate></v-progress-circular>
    </v-flex>
  </v-layout>
  <div v-else>
    <v-layout v-if="linkedTask.type === 'Reading'" class="pt-3" row wrap justify-center>
      <v-flex xs12 sm11 md10 lg8>
        <v-card class="px-2 mx-2 py-2 elevation-0">
          <div class="display-1 text-xs-center"><b>{{linkedTask.name}}</b></div>
          <v-divider class="my-3"></v-divider>
          <div class="quill-unit title pb-4" v-html="linkedTask.text"></div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-if="linkedTask.type === 'Lecture'" @contextmenu.prevent="" row wrap justify-center>
      <v-flex v-if="videoUrl == ''" class="py-5 my-5 text-xs-center" xs12 md10>
        <div class="display-1 grey--text text--lighten-2">No Video Uploaded</div>
      </v-flex>
      <v-flex v-else class="py-4 text-xs-center" xs12 md10>
        <video id="lecture-player" class="video-js lecture-video" preload="none" data-setup='{}' controls>
          <source type="video/mp4" :src="videoUrl">
        </video>
      </v-flex>
    </v-layout>
    <r-test-preview v-if="linkedTask.type === 'Practice' || linkedTask.type === 'NCLEX'"></r-test-preview>
  </div>
</div>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/storage'
import videojs from 'video.js'
import TestPreview from './TestPreview.vue'
export default {
  components: {
    rTestPreview: TestPreview
  },
  data: () => ({
    loading: false,
    linkedTask: {},
    taskData: {},
    videoUrl: '',
    videoRef: null,
    video: null
  }),
  beforeMount () {
    this.load()
  },
  updated () {
    if (this.video === null && this.videoUrl !== '') {
      try {
        this.video = videojs('lecture-player')
      } catch (err) {}
    }
  },
  beforeDestroy () {
    if (this.video) this.video.dispose()
  },
  methods: {
    load () {
      this.loading = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      let sectionData = {}
      for (let s of this.$store.getters.sectionByContent(contentData.key)) {
        if (s.url === this.$route.params.sectionUrl) sectionData = s
      }
      for (let t of this.$store.getters.taskBySection(sectionData.key)) {
        if (t.url === this.$route.params.taskUrl) {
          this.linkedTask = this.$store.getters.taskByKey(t.linkedTaskKey)
          this.taskData = t
        }
      }
      if (this.linkedTask.type === 'Lecture') {
        this.videoRef = firebase.storage().ref().child('lectures').child(this.linkedTask.key)
        if (this.linkedTask.fileName.length > 0) {
          let fileRef = this.videoRef.child(this.linkedTask.fileName)
          fileRef.getDownloadURL().then(downloadUrl => {
            this.videoUrl = downloadUrl
            this.loading = false
          })
        } else {
          this.videoUrl = ''
          this.loading = false
        }
      } else this.loading = false
    }
  }
}
</script>

<style>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.lecture-video {
  max-width: 100%;
  height: 375px;
}
.invisible {
  width: 0.1px  !important;
  height: 0.1px  !important;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/content/LinkedPreview.vue